<template>
  <v-card v-if="currentIngredientType">
    <v-card-title>
      <h2 class="modal-title">{{ $t('base.edit_ingredient_type') }}</h2>
    </v-card-title>
    <v-card-content>
      <v-text-field
        :label="$t('base.type_ingredient_type_name')"
        v-model="currentIngredientType.name"
      />
    </v-card-content>
    <v-card-actions>
      <v-btn @click="onUpdate" :loading="loading">
        {{ $t('base.save') }}
      </v-btn>
      <delete-btn @delete="onDelete" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsIngredientTypeModal',

  components: {
    DeleteBtn
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters('ingredienttypes', [
      'currentIngredientType'
    ])
  },

  methods: {
    ...mapActions('ingredienttypes', [
      'updateIngredientType',
      'deleteIngredientType'
    ]),

    async onUpdate () {
      this.loading = true

      const error = await this.updateIngredientType()

      this.loading = false

      if (!error) {
        this.$emit('update')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    },

    async onDelete () {
      await this.deleteIngredientType()
      this.$emit('remove')
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex: 1;
}
</style>